module.exports = __webpack_public_path__ + "static/media/haimian-zhangwanguoji.234bfc53.png";